import type { SVGProps } from "react";

const SvgSwanSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="46.0 46.0 420.0 420.0"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path fill="#14191A" d="M46 46h420v420H46z" />
    <path
      fill="#fff"
      d="M289.558 387.775h-42.1C176.463 387.775 126 326.096 126 255.942 126 185.823 180.162 124 253.981 124 332.284 124 386 171.167 386 244.611v144.122h-45.835V244.611c0-46.643-31.951-74.709-86.184-74.709-47.068 0-82.147 40.047-82.147 86.04 0 46.607 32.166 85.931 75.624 85.931h42.1z"
    />
  </svg>
);
export default SvgSwanSmallLogo;
